import React, { useEffect, useState } from 'react';
import { Chart } from '@antv/g2';
import type { RadioChangeEvent } from 'antd';
import { Button, Modal, Radio, Table } from 'antd';
import type { CheckboxGroupProps } from 'antd/es/checkbox';
import { useSnapshot } from 'valtio';
import {
  adClicksApi,
  clickTrendApi,
  desktopTrendApi,
  functionRankingApi,
  overviewByCrmApi,
  pageTrendApi,
} from '@/api/feature/feature';
import charImage from '@/assets/images/chart-bar.png';
import Iconfont from '@/component/Icon/index';
import { state } from '@/store/index';
import styles from './index.module.scss';

const plainOptions: CheckboxGroupProps<string>['options'] = ['Apple', 'Pear', 'Orange'];

const options: CheckboxGroupProps<string>['options'] = [
  { label: '15天', value: '15', className: 'label-1' },
  { label: '30天', value: '30', className: 'label-2' },
];

const FeatureViewStatistics: React.FC = () => {
  const [time, setTime] = useState('15');
  const [sysCustomerInfo, setSysCustomerInfo] = useState({} as any);
  const [tableData1, setTableData1] = useState([] as any);
  const [tableData2, setTableData2] = useState([] as any);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalText, setModalText] = useState('');
  const { currentShopPlatformType } = useSnapshot(state);

  const tableClick = async (record: any) => {
    setModalText('点击广告数据');

    const res = await clickTrendApi({ elementId: record.elementId, shopId: state.currentShopId, period: time });
    console.log(res);
    let chartData = [] as any;
    res.data.dates.map((item: any, index: number) => {
      const i = {
        date: item.split('-').splice(1, 2).join('.'),
        value: res.data.clickCounts[index],
      };
      chartData.push(i);
    });
    setIsModalOpen(true);

    setTimeout(() => {
      const chart = new Chart({
        container: 'pageDetailData',
        autoFit: true,
      });
      chart
        .data(chartData)
        .encode('x', 'date')
        .encode('y', 'value')
        .axis('y', { title: '点击量' })
        .axis('x', { title: '日期', labelTransform: 'rotate(0)' });
      chart.line().encode('shape', 'smooth');
      chart.render();
    }, 100);
  };
  const columns1: any[] = [
    {
      title: '广告标题',
      key: 'adTitle',
      dataIndex: 'adTitle',
      width: '250px',
    },
    {
      title: '点击量',
      dataIndex: 'clickCount',
      key: 'clickCount',
    },
    {
      title: '',
      dataIndex: 'analysisStatus',
      key: 'analysisStatus',
      width: '200px',
      render: (value: any, record: any, index: number) => (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            tableClick(record);
          }}>
          <Iconfont icon={'BarChartOutlined'}></Iconfont>
        </div>
      ),
    },
  ];

  const columns2: any[] = [
    {
      title: '广告标题',
      key: 'adTitle',
      dataIndex: 'adTitle',
      width: '250px',
    },
    {
      title: '点击量',
      dataIndex: 'clickCount',
      key: 'clickCount',
    },
    {
      title: '',
      dataIndex: 'analysisStatus',
      key: 'analysisStatus',
      width: '200px',
      render: (value: any, record: any, index: number) => (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            tableClick(record);
          }}>
          <Iconfont icon={'BarChartOutlined'}></Iconfont>
        </div>
      ),
    },
  ];
  const CustomerData = ({ sysCustomerInfo }: { sysCustomerInfo: any }) => {
    console.log(sysCustomerInfo);

    const cardList = [
      {
        label: '会员中心访问数（PV）',
        value: sysCustomerInfo.desktopCenterPV ? sysCustomerInfo.desktopCenterPV : 0,
      },
      {
        label: '会员中心访问人数（UV）',
        value: sysCustomerInfo.desktopCenterUV ? sysCustomerInfo.desktopCenterUV : 0,
      },
    ];
    console.log(cardList);
    return (
      <div className={styles.CustomerData}>
        <div className={styles.smallCardList}>
          {cardList.map((it: any, index: number) => (
            <div
              className={styles.smallCardItem}
              key={it.label}
              style={{ marginRight: index === cardList.length - 1 ? '0px' : '24px' }}>
              <div className={styles.cardTitle}>{it.label}</div>
              <div className={styles.customerData}>{it.value.toLocaleString('en-US')}</div>
              <img
                className={styles.customerImg}
                src={it.img}
                alt=""
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  const onChange3 = ({ target: { value } }: RadioChangeEvent) => {
    setTime(value);
  };

  const pageDataGen = (data: any) => {
    const chart = new Chart({
      container: 'pageData',
      autoFit: true,
    });

    chart
      .data(data)
      .encode('x', 'date')
      .encode('y', 'value')
      .encode('color', 'key')
      .scale('x', {
        range: [0, 1],
      })
      .scale('y', {
        nice: true,
        title: '人数',
      })
      .axis('y', { title: '人数' })
      .axis('x', { title: '日期' });

    chart.line().encode('shape', 'smooth');

    chart.point().encode('shape', 'point').tooltip(false);

    chart.render();
  };

  const medal = (chart: any, datum: any) => {
    const { document } = chart.getContext().canvas!;
    const group = document.createElement('g', {});
    const icon = document.createElement('image', {
      style: {
        src: charImage,
        width: 15,
        height: 15,
        transform: `translate(-15, -8)`,
        cursor: 'pointer',
      },
    });
    icon.addEventListener('click', async () => {
      setModalText(datum);
      let pageId = '';
      switch (datum) {
        case '会员首页':
          pageId = 'member_home';
          break;
        case '积分商城页':
          pageId = 'points_mall';
          break;
        case '宠物信息':
          pageId = 'pet_info';
          break;
        case '喂养助手':
          pageId = 'feeding_assistant';
          break;
        case '会员卡':
          pageId = 'member_card';
          break;
        case '宠物中心':
          pageId = 'pet_center';
          break;
        default:
          break;
      }
      const res = await pageTrendApi({ pageId, shopId: state.currentShopId, period: time });
      console.log(res);
      let data = [] as any;
      res.data.dates.map((item: any, index: number) => {
        data.push({
          date: item.split('-').splice(1, 2).join('.'),
          value: res.data.pv[index],
          key: 'pv',
        });
        data.push({
          date: item.split('-').splice(1, 2).join('.'),
          value: res.data.uv[index],
          key: 'uv',
        });
      });
      setIsModalOpen(true);

      setTimeout(() => {
        const chart = new Chart({
          container: 'pageDetailData',
          autoFit: true,
        });

        chart
          .data(data)
          .encode('x', 'date')
          .encode('y', 'value')
          .encode('color', 'key')
          .scale('x', {
            range: [0, 1],
          })
          .scale('y', {
            nice: true,
            title: '人数',
          })
          .axis('y', { title: '人数' })
          .axis('x', { title: '日期' });

        chart.line().encode('shape', 'smooth');

        chart.point().encode('shape', 'point').tooltip(false);

        chart.render();
      }, 100);
    });
    const label = document.createElement('text', {
      style: {
        text: datum,
        fontSize: 12,
        with: 100,
        textAlign: 'right',
        transform: `translate(-25, 6)`,
      },
    });
    group.appendChild(icon);
    group.appendChild(label);
    return group;
    // return medals[index];
  };

  const featureDataGen = (data: any) => {
    const chart = new Chart({
      container: 'featureData',
      autoFit: true,
    });

    chart
      .interval()
      .coordinate({ transform: [{ type: 'transpose' }] })
      .data(data)
      .encode('x', 'functionName')
      .encode('y', 'value')
      .encode('color', 'key')
      .transform({ type: 'dodgeX' })
      .interaction('tooltip', { shared: true })
      .axis('x', { title: '', labelFormatter: (datum: any, index: number) => medal(chart, datum) })
      .axis('y', { title: '' });

    chart.render();
  };

  const overviewByCrm = async () => {
    const res = await overviewByCrmApi({ shopId: state.currentShopId, period: time });
    console.log(res);
    setSysCustomerInfo(res.data);
  };

  const desktopTrend = async () => {
    const res = await desktopTrendApi({ shopId: state.currentShopId, period: time });
    console.log(res);
    let data = [] as any;
    res.data.dates.map((item: any, index: number) => {
      data.push({
        date: item.split('-').splice(1, 2).join('.'),
        value: res.data.pv[index],
        key: 'pv',
      });
      data.push({
        date: item.split('-').splice(1, 2).join('.'),
        value: res.data.uv[index],
        key: 'uv',
      });
    });
    pageDataGen(data);
  };

  const functionRanking = async () => {
    const res = await functionRankingApi({ shopId: state.currentShopId, period: time });
    console.log(res);
    let data = [] as any;
    res.data.map((item: any, index: number) => {
      data.push({
        functionName: item.functionName,
        value: item.pv,
        key: 'pv',
      });
      data.push({
        functionName: item.functionName,
        value: item.uv,
        key: 'uv',
      });
    });
    console.log(data);
    featureDataGen(data);
  };

  const adClicks = async (adType: string) => {
    const res = await adClicksApi({ shopId: state.currentShopId, period: time, adType });
    if (adType === 'points_mall_ad') {
      setTableData1(res.data.pointsQuery);
    } else {
      setTableData2(res.data.pointsQuery);
    }
  };

  useEffect(() => {
    overviewByCrm();
    desktopTrend();
    functionRanking();
    adClicks('points_mall_ad');
    adClicks('points_mall_marketing');
  }, [time]);

  return (
    <div style={{ padding: 24 }}>
      <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 16 }}>功能统计</div>
      <Radio.Group
        style={{ marginTop: '20px' }}
        options={options}
        onChange={onChange3}
        value={time}
        optionType="button"
      />
      <CustomerData sysCustomerInfo={sysCustomerInfo} />

      <div style={{ fontSize: 18, marginTop: 30, fontWeight: 'bold' }}>页面访问数据</div>
      <div id="pageData"></div>
      <div style={{ fontSize: 18, marginTop: 30, fontWeight: 'bold' }}>功能访问量</div>
      <div id="featureData"></div>
      <div style={{ fontSize: 18, marginTop: 30, fontWeight: 'bold' }}>广告点击</div>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: 16 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 16, marginTop: 16 }}>积分商城头图</div>
          <Table
            columns={columns1}
            dataSource={tableData1}
            pagination={false}
          />
        </div>
        {currentShopPlatformType !== 'TM' && (
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, marginTop: 16 }}>营销活动模块</div>
            <Table
              columns={columns2}
              dataSource={tableData2}
              pagination={false}
            />
          </div>
        )}
      </div>

      <Modal
        title={modalText}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        footer={null}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        width={1000}>
        <div id="pageDetailData"></div>
      </Modal>
    </div>
  );
};

export default FeatureViewStatistics;
